<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">Lista de Perfis</h4>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div>
                <el-select
                  class="select-success mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-success"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
              <div
                class="d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div>
                  <base-input>
                    <el-input
                      type="search"
                      class="mb-3 search-input"
                      color="success"
                      clearable
                      prefix-icon="el-icon-search"
                      placeholder="Pesquisar perfil"
                      v-model="searchQuery"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </base-input>
                </div>
                <div>
                  <base-button
                    type="success"
                    class="animation-on-hover"
                    style="margin: 0px 5px 0px 5px;"
                    @click="mostrarDialog('Cadastrar')"
                    >Cadastrar Perfil</base-button
                  >
                </div>
              </div>
            </div>
            <el-table :data="queriedData">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
              <el-table-column :min-width="135" align="right" label="Ações">
                <div slot-scope="props">
                  <el-tooltip
                    content="Editar"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      @click="mostrarDialog('Alterar', props.row)"
                      class="edit btn-link"
                      type="info"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>
                  </el-tooltip>

                  <!-- <el-tooltip content="Excluir" effect="light" :open-delay="300" placement="top">
                                        <base-button class="remove btn-link" type="danger" size="sm" icon
                                            @click="excluirDialog(props.row)">
                                            <i class="tim-icons icon-simple-remove"></i>
                                        </base-button>
                                    </el-tooltip> -->
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="font-weight-normal">
                Mostrando de {{ from + 1 }} a {{ to }} no total de
                {{ total }} Perfis.
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="dialogCadPerfil">
      <template slot="header">
        <h4 class="modal-title" id="exampleModalLabel">
          {{ tipo }}
        </h4>
      </template>
      <div class="row">
        <div class="col-md-12 pr-md-1 text-left">
          <base-input
            label="Descrição"
            placeholder="Descrição"
            v-model="descricao"
            :class="erros.descricao === true ? 'has-danger' : ''"
          >
          </base-input>
        </div>
        <div class="col-md-12 pr-md-1 text-left fixFuncionalidade">
          <base-input label="Funcionalidades:">
            <base-checkbox
              v-for="funcionalidade in funcionalidadesData"
              :key="funcionalidade.idFuncionalidade"
              v-model="funcionalidade.status"
              >{{ funcionalidade.descricao }}</base-checkbox
            >
          </base-input>
        </div>
      </div>
      <template slot="footer">
        <div class="w-100 d-flex justify-content-end">
          <base-button
            type="success"
            @click="tipo === 'Alterar' ? editarPerfil() : cadastrarPerfil()"
            >Salvar</base-button
          >
        </div>
      </template>
    </modal>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import Fuse from "fuse.js";
import Modal from "@/components/Modal.vue";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
    Modal,
  },
  computed: {
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      tipo: "",
      descricao: "",
      funcionalidades: [],
      funcionalidadesData: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10],
        total: 0,
      },
      isLoading: false,
      dialogCadPerfil: false,
      searchQuery: "",
      propsToSearch: ["descricao"],
      tableColumns: [
        {
          prop: "descricao",
          label: "Descrição",
          minWidth: 300,
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      perfilSelecionado: {
        id: "",
        descricao: "",
        funcionalidades: [],
      },
      erros: {
        descricao: "",
      },
    };
  },
  mounted() {
    this.listarPerfis();
    this.listarFuncionalidades();
  },
  methods: {
    inicializarFuse() {
      this.fuseSearch = new Fuse(this.tableData, {
        keys: ["descricao"],
        threshold: 0.3,
      });
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    listarFuncionalidades() {
      let th = this;
      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/usuarios/listarFuncionalidades", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          if (response.data.data.length > 0) {
            th.funcionalidades = response.data.data.map((d) => {
              const item = {
                descricao: d.descricao,
                path: d.path,
                idPerfil: d.idPerfil,
                idFuncionalidade: d.idFuncionalidade,
                status: (d.status = d.status == "true" ? true : false),
              };
              return item;
            });
          } else {
            th.funcionalidades = [];
          }
        })
        .catch((err) => {
          th.showSwal("auto-close", "Erro", "Erro ao listar!", "error");
        });
    },

    listarPerfis() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/usuarios/listarPerfil", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.data.length > 0) {
            th.tableData = response.data.data;
          } else {
            th.tableData = [];
          }
          th.inicializarFuse();
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal("auto-close", "Erro", "Erro ao listar!", "error");
        });
    },

    cadastrarPerfil() {
      if (this.validarCampos()) {
        let th = this;
        this.isLoading = true;

        let bodyFormData = {
          setDB: this.$cookies.get("db"),
          descricao: this.descricao,
          funcionalidades: this.funcionalidadesData,
        };

        this.axios
          .post("/api/usuarios/criarPerfil", bodyFormData, {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          })
          .then((response) => {
            th.isLoading = false;
            th.dialogCadPerfil = false;
            th.listarPerfis();
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Cadastrado realizado com sucesso!",
              "success",
            );
          })
          .catch((err) => {
            th.isLoading = false;
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao cadastrar perfil!",
              "error",
            );
          });
      } else {
        this.showSwal(
          "auto-close",
          "Erro",
          "Preencha os campos obrigatórios",
          "error",
        );
      }
    },

    async mostrarDialog(tipo, row) {
      //limpando possivel lixo
      this.erros.descricao = "";
      this.dialogCadPerfil = true;
      this.tipo = tipo;
      this.descricao = "";
      this.perfilSelecionado = "";

      this.funcionalidadesData = this.funcionalidades.map((fn) => {
        const item = {
          descricao: fn.descricao,
          path: fn.path,
          idPerfil: fn.idPerfil,
          idFuncionalidade: fn.idFuncionalidade,
          status: false,
        };
        return item;
      });

      if (row) {
        this.descricao = row.descricao;

        this.funcionalidadesData = this.funcionalidadesData.map((fn) => {
          const funcao = row.funcionalidades.find(
            (f) => f.idFuncionalidade === fn.idFuncionalidade,
          );

          const item = {
            ...fn,
            status:
              funcao && (funcao.status == "true" || funcao.status == true)
                ? true
                : false,
            idPerfil: row.id,
          };
          return item;
        });
        this.perfilSelecionado = row;
      }
    },

    async excluirDialog(row) {
      this.perfilSelecionado = row;

      swal({
        title: "Tem certeza?",
        text: `Deseja realmente excluir o perfil?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Não!",
        buttonsStyling: false,
      })
        .then((response) => {
          if (response.value) {
            this.excluirPerfil();
          }
        })
        .catch((err) => {});
    },

    excluirPerfil() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: this.perfilSelecionado.id,
      };

      this.axios
        .post("/api/usuarios/deletarPerfil", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.dialogCadPerfil = false;
          th.listarPerfis();
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Excluído com sucesso!",
            "success",
          );
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal("auto-close", "Erro", "Erro ao excluir perfil!", "error");
        });
    },

    editarPerfil() {
      if (this.validarCampos()) {
        let th = this;
        this.isLoading = true;

        let bodyFormData = {
          setDB: this.$cookies.get("db"),
          id: this.perfilSelecionado.id,
          descricao: this.descricao,
          funcionalidades: this.funcionalidadesData,
        };

        this.axios
          .post("/api/usuarios/editarPerfil", bodyFormData, {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          })
          .then((response) => {
            th.isLoading = false;
            th.dialogCadPerfil = false;
            th.listarPerfis();
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Atualizado com sucesso!",
              "success",
            );
          })
          .catch((err) => {
            th.isLoading = false;
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao atualizar perfil!",
              "error",
            );
          });
      } else {
        this.showSwal(
          "auto-close",
          "Erro",
          "Preencha os campos obrigatórios",
          "error",
        );
      }
    },

    validarCampos() {
      let status = true;
      if (this.descricao === "") {
        this.erros.descricao = true;
        status = false;
      } else {
        this.erros.descricao = false;
      }

      return status;
    },
  },
  watch: {
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style>
.fixFuncionalidade {
  max-height: 300px;
  overflow: auto;
}

.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
</style>
